/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, Theme, useTheme } from 'bold-ui'
import { Box } from 'components/Box'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { MCHAT_PERGUNTAS } from '../../mchat/model-mchat'
import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import {
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoPassouFalhouMap,
  PassouFalhouEnum,
} from '../model-consultaSeguimento'

interface ConsultaSeguimentoResultadoTableProps {
  aplicacao: ConsultaSeguimentoAplicacaoModel
}

export function ConsultaSeguimentoResultadoTable(props: Readonly<ConsultaSeguimentoResultadoTableProps>) {
  const { aplicacao } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const perguntas = Object.keys(aplicacao) as MChatPerguntaEnum[]

  return (
    <Box style={styles.table}>
      {perguntas.map((pergunta) => (
        <HFlow alignItems='center' justifyContent='space-between' key={pergunta}>
          <Text>
            {getMChatPerguntaNumber(pergunta)}. “{MCHAT_PERGUNTAS[pergunta]}”
          </Text>
          <Text
            color={aplicacao[pergunta].resultado === PassouFalhouEnum.PASSOU ? 'success' : 'danger'}
            fontWeight='bold'
            style={styles.value}
          >
            {ConsultaSeguimentoPassouFalhouMap[aplicacao[pergunta].resultado].title}
          </Text>
        </HFlow>
      ))}
    </Box>
  )
}

const createStyles = (theme: Theme) => ({
  table: css`
    padding: 0;
    & > div {
      border-bottom: 1px solid ${theme.pallete.divider};
      margin: 0;
      padding: 0.25rem 1rem;
      &:last-child {
        border-bottom: 0;
      }
    }
  `,
  value: css`
    width: 2.75rem;
  `,
})
